// includes/auth/transactionCenterApi.js
//
// API layer for the Family Transaction Center (server:
// elakay_routes/transactionCenter.js, Family-only, plain JSON -- same
// apiFetch shape as monitoringApi.js / apiDbAdmin.js).
import { elakay_API } from "../../config";
import { isAuthenticated } from "../auth";

const getToken = () => isAuthenticated()?.token || "";

export const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      if (value.length) query.set(key, value.join(","));
      return;
    }
    query.set(key, String(value));
  });
  const text = query.toString();
  return text ? `?${text}` : "";
};

const apiFetch = async (path, { method = "GET", params, token, signal } = {}) => {
  const headers = { Accept: "application/json" };
  const resolved = token || getToken();
  if (resolved) headers.Authorization = `Bearer ${resolved}`;
  const response = await fetch(`${elakay_API}${path}${buildQuery(params)}`, { method, headers, signal });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    const error = new Error(data.error || `Transaction Center error ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return data;
};

const BASE = "/family/transaction-center";

export const getTransactionsAPI = (params, opts) => apiFetch(`${BASE}/transactions`, { params, ...opts });
export const getOrdersAPI = (params, opts) => apiFetch(`${BASE}/orders`, { params, ...opts });
export const getWalletAPI = (params, opts) => apiFetch(`${BASE}/wallet`, { params, ...opts });
export const getTransactionDetailAPI = (key, opts) => apiFetch(`${BASE}/detail`, { params: { key }, ...opts });
export const getTransactionOptionsAPI = (opts) => apiFetch(`${BASE}/options`, opts);
export const getReconciliationAPI = (params, opts) => apiFetch(`${BASE}/reconcile`, { params, ...opts });
export const rebuildLedgerAPI = (opts) => apiFetch(`${BASE}/rebuild`, { method: "POST", ...opts });
